<div class="wk-media-properties" *ngIf="mediaType === mediaImage">
  <div class="wk-field wk-field-small">
    <div class="wk-field-header">
      <label class="wk-field-label" for="Name">
        {{ 'CORE.METADATA.MEDIA_PROP.NAME' | translate }}
      </label>
    </div>
    <div class="wk-field-body">
      <input
        type="text"
        placeholder="{{
          'CORE.METADATA.FORM_TEXT.NAME_PLACEHOLDER' | translate
        }}"
        autocomplete="off"
        class="wk-field-input img-text"
        [(ngModel)]="imageName"
        title="{{ imageName }}"
        readonly
      />
    </div>
  </div>
  <div class="wk-field wk-field-small">
    <div class="wk-field-header">
      <label class="wk-field-label" for="Alternative_text">
        {{ 'CORE.METADATA.MEDIA_PROP.ALT_TEXT' | translate }}
      </label>
    </div>
    <div class="wk-field-body">    
 <textarea
      #altTextarea
      id="Alternative_text"
      autocomplete="off"
      placeholder="{{
          'CORE.METADATA.FORM_TEXT.ALT_TEXT_PLACEHOLDER' | translate
        }}"
      class="wk-field-input img-text alt-textarea"
      [(ngModel)]="imageAlternativeText"
       (ngModelChange)="changeAltTxt(imageAlternativeText)"
      [readonly]="!editable"
      title="{{ imageAlternativeText }}"
      rows="1"
    ></textarea>

    </div>
    <div class="warning-box">
      <error-widget
        class="wk-field"
        [required]="'CORE.METADATA.FORM_TEXT.WARNING_MESSAGE' | translate"
        *ngIf="isInvalidAltText"
      ></error-widget>
    </div>
  </div>

  <div class="custom-height-width-box">
    <div class="wk-field wk-field-small">
      <div class="wk-field-header">
        <label class="wk-field-label" for="Width">
          {{ 'CORE.METADATA.MEDIA_PROP.WIDTH' | translate }}
        </label>
      </div>
      <div class="wk-field-body">
        <input
          type="number"
          placeholder="{{ 'CORE.METADATA.MEDIA_PROP.WIDTH' | translate }}"
          autocomplete="off"
          class="wk-field-input img-input"
          [(ngModel)]="imageWidth"
          (ngModelChange)="changeWidth(imageWidth)"
          [readonly]="editable ? false : true"
          (keydown)="allowNumbersOnly($event)"
        />
      </div>
    </div>
    <div class="wk-field wk-field-small height-box">
      <div class="wk-field-header">
        <label class="wk-field-label" for="Height">
          {{ 'CORE.METADATA.MEDIA_PROP.HEIGHT' | translate }}
        </label>
      </div>
      <div class="wk-field-body">
        <input
          type="number"
          placeholder="{{ 'CORE.METADATA.MEDIA_PROP.HEIGHT' | translate }}"
          autocomplete="off"
          class="wk-field-input img-input"
          [(ngModel)]="imageHeight"
          (ngModelChange)="changeHeight(imageHeight)"
          [readonly]="editable ? false : true"
          (keydown)="allowNumbersOnly($event)"
        />
      </div>
    </div>
    <div class="wk-docs-icons" [ngClass]="{ 'disable-icon': !editable }">
      <span
        *ngIf="enableLock === false"
        title="lock"
        class="wk-icon-lock lock"
        (click)="enableLockIcon()"
        (keyup)="enableLockIcon()"
      ></span>
      <span
        *ngIf="enableLock === true"
        title="unlock"
        class="wk-icon-lock-open lock"
        (click)="enableLockIcon()"
        (keyup)="enableLockIcon()"
      ></span>
      <span
        title="restore"
        class="wk-icon-refresh refresh"
        (click)="restore('iconClick')"
        (keyup)="restore('iconClick')"
      ></span>
    </div>
  </div>
  <div class="height-width-message">
    <error-widget
      class="wk-field height-box"
      *ngIf="isInvalid"
      required="{{ 'CORE.METADATA.FORM_TEXT.WARNING_MESSAGE' | translate }}"
    ></error-widget>
  </div>
  <div
    class="wk-field wk-field-small wk-field-horizontal-choices docs-checkbox-radio"
    aria-labelledby="group-id-2"
  >
    <div class="wk-field-header">
      <label class="wk-field-label" id="group-id-2" for="Alignment">
        {{ 'CORE.METADATA.MEDIA_PROP.ALIGNMENT' | translate }}
      </label>
    </div>
    <div class="wk-field-body">
      <label
        class="wk-field-choice-label"
        *ngFor="let alignment of alignmentGroup"
      >
        <input
          type="radio"
          name="horizontal-group"
          [value]="alignment"
          class="wk-field-choice"
          [attr.checked]="alignmentSelected == alignment ? true : null"
          [(ngModel)]="alignmentSelected"
          (change)="changeAlignment(alignmentSelected)"
          [disabled]="
            (editable ? false : true) || (disableAlignment ? true : false)
          "
        />
        <span class="wk-field-choice-text">{{ capitalize(alignment) }}</span>
      </label>
    </div>
  </div>
</div>
<div
  class="wk-media-properties"
  *ngIf="mediaType === 'AUDIO' || mediaType === 'VIDEO'"
>
  <div class="wk-field wk-field-small">
    <div class="wk-field-header">
      <label class="wk-field-label" for="Title">
        {{ 'CORE.METADATA.MEDIA_PROP.TITLE' | translate }}
      </label>
    </div>
    <div class="wk-field-body">
      <input
        type="text"
        placeholder="Title"
        autocomplete="off"
        title="{{ mediaTitle }}"
        class="wk-field-input media-text"
        [(ngModel)]="mediaTitle"
        readonly
      />
    </div>
  </div>
  <div class="wk-field wk-field-small">
    <div class="wk-field-header">
      <label class="wk-field-label" for="Name">
        {{ 'CORE.METADATA.MEDIA_PROP.NAME' | translate }}
      </label>
    </div>
    <div class="wk-field-body">
      <input
        type="text"
        placeholder="Name"
        autocomplete="off"
        title="{{ mediaName }}"
        class="wk-field-input media-text"
        readonly
        [(ngModel)]="mediaName"
      />
    </div>
  </div>
  <div class="wk-field wk-field-small">
    <div class="wk-field-header">
      <label class="wk-field-label" for="Description">
        {{ 'CORE.METADATA.MEDIA_PROP.DESCRIPTION' | translate }}
      </label>
    </div>
    <div class="wk-field-body">
      <input
        type="text"
        placeholder="Enter Text"
        autocomplete="off"
        class="wk-field-input media-text"
        [(ngModel)]="mediaDesc"
        title="{{ mediaDesc }}"
        (ngModelChange)="changeMediaDesc(mediaDesc)"
      />
    </div>
  </div>
  <div class="wk-field wk-field-small">
    <div class="wk-field-header">
      <label class="wk-field-label" for="Credit line">
        {{ 'CORE.METADATA.MEDIA_PROP.CRED_LINE' | translate }}
      </label>
    </div>
    <div class="wk-field-body">
      <input
        type="text"
        placeholder="Enter Text"
        autocomplete="off"
        class="wk-field-input media-text"
        [(ngModel)]="mediaCredLine"
        title="{{ mediaCredLine }}"
        (ngModelChange)="changeMediaCredLine(mediaCredLine)"
      />
    </div>
  </div>
</div>
